import { render, staticRenderFns } from "./PriceClassForm.vue?vue&type=template&id=8cb1be8e&scoped=true"
import script from "./PriceClassForm.vue?vue&type=script&lang=ts"
export * from "./PriceClassForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb1be8e",
  null
  
)

export default component.exports